import { UserCenterMenuEnum } from "@/apis/model/UserCenterMenuEnum";
import { urlForCenterMenu } from "@/pages/centerUrlHelper";
import { pathForUserCenterPage } from "../../userCenterMenus";
import { NotificationTab } from "./notificationUtils";

export const LAYOUT_NOTIFICATION_PAGE_SIZE = 10;
export const MAX_LAYOUT_NOTIFICATION_PAGE_COUNT = 5;

export const NOTIFICATION_PAGE_SIZE = LAYOUT_NOTIFICATION_PAGE_SIZE * MAX_LAYOUT_NOTIFICATION_PAGE_COUNT;

export interface IMyNotificationsQuery {
  tab?: NotificationTab;
  id?: string;
}

export function myNotificationTabUrl(query: IMyNotificationsQuery): string {
  const url = pathForUserCenterPage(UserCenterMenuEnum.MyNotifications);
  if (!query.tab) {
    return url;
  }
  return url + "?tab=" + query.tab;
}

export function goMyNotificationsTab(query: IMyNotificationsQuery): void {
  window.open(urlForCenterMenu(UserCenterMenuEnum.MyNotifications, query));
}
